import CopilotProvider from 'copilot-toolkit/CopilotProvider';
// @ts-expect-error untyped
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import { Application as ApplicationComponent } from 'foundations-components/components/Application';
import { createBrowserHistory } from 'history';
import { renderWithNavCopilot } from 'quartz-core/client-with-copilot';
import UITour from 'ui-shepherd-react/tour/UITour';
import CrmCommandHandler from 'crm-command-handler/CrmCommandHandler';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';

// Redux
import { Provider } from 'react-redux';
import { getAuth } from './actions/AuthActions';
import configureStore from './utils/configureStore';
import { getI18nProvider } from './utils/I18n';
// Configure the router
import { Router } from 'react-router-dom';
import Application from './Application';
import Routes from './components/Routes';
import { getUserPrimaryTeam } from './selectors/authSelectors';
import { getRootUrl } from './utils/urls';
import { AccessLevelContextProvider } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { setUpReportingPrimaryTracker } from './utils/setUpReportingPrimaryTracker';
import { ONBOARDING_FORECAST_TOUR, ONBOARDING_FORECAST_TOUR_WITHOUT_AI, EXISTING_USER_FMO_TOUR, ONBOARDING_V2_TOUR, ONBOARDING_V2_TOUR_WITHOUT_ANALYZE } from './constants/TourConstants';
import tourHandler from './utils/tourHandler';
import ApolloContainer from './ApolloContainer';
import OnboardingAnalyzeTabTourStep from './components/tour/OnboardingAnalyzeTabTourStep';
import OnboardingForecastCategoryTabTourStep from './components/tour/OnboardingForecastCategoryTabTourStep';
import { SET_SESSION_DATE } from './actions/ActionTypes';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const tours = [ONBOARDING_FORECAST_TOUR, ONBOARDING_FORECAST_TOUR_WITHOUT_AI, EXISTING_USER_FMO_TOUR, ONBOARDING_V2_TOUR, ONBOARDING_V2_TOUR_WITHOUT_ANALYZE];
const App = ({
  store
}) => {
  const history = createBrowserHistory({
    basename: getRootUrl()
  });
  return /*#__PURE__*/_jsx(ApplicationComponent, {
    name: "forecasting-ui",
    children: /*#__PURE__*/_jsx(CopilotProvider, {
      children: /*#__PURE__*/_jsx(ApolloContainer, {
        children: /*#__PURE__*/_jsx(Provider, {
          store: store,
          children: /*#__PURE__*/_jsx(RhumbProvider, {
            config: rhumbConfig,
            history: historyAdapter(history),
            children: /*#__PURE__*/_jsx(Router, {
              history: history,
              children: /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
                children: /*#__PURE__*/_jsxs(Application, {
                  children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsxs(UITour, {
                    multiTourHandler: tourHandler,
                    tours: tours,
                    children: [/*#__PURE__*/_jsx(OnboardingForecastCategoryTabTourStep, {}), /*#__PURE__*/_jsx(OnboardingAnalyzeTabTourStep, {}), /*#__PURE__*/_jsxs(AccessLevelContextProvider, {
                      children: [/*#__PURE__*/_jsx(Routes, {
                        primaryTeam: getUserPrimaryTeam(store.getState())
                      }), /*#__PURE__*/_jsx(CrmCommandHandler, {
                        i18nLoader: getI18nProvider()
                      })]
                    })]
                  })]
                })
              })
            })
          })
        })
      })
    })
  });
};
export const startApp = async () => {
  const store = configureStore();
  const I18nProvider = getI18nProvider();

  // Reporting Primary Tracker setup
  setUpReportingPrimaryTracker();
  const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
  const {
    user,
    portal
  } = await store.dispatch(getAuth());
  I18nProvider.setLocale({
    locale: user.locale,
    langEnabled: user.lang_enabled,
    timezone: portal.timezone
  });
  await langAvailable;
  store.dispatch({
    type: SET_SESSION_DATE
  });
  const layoutType = 'panel-with-scroll';
  renderWithNavCopilot( /*#__PURE__*/_jsx(App, {
    store: store
  }), {
    layoutType
  });
};